import { render, staticRenderFns } from "./PlanListItemDetails.vue?vue&type=template&id=4c5f399a&"
import script from "./PlanListItemDetails.vue?vue&type=script&lang=js&"
export * from "./PlanListItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./PlanListItemDetails.vue?vue&type=style&index=0&id=4c5f399a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports